import { ReactComponent as Repeat } from "@material-icons/svg/svg/repeat/outline.svg";
import { ReactComponent as ContextMenu } from "@material-icons/svg/svg/more_vert/outline.svg";
import { ReactComponent as Info } from "@material-icons/svg/svg/info/outline.svg";
import { ReactComponent as Edit } from "@material-icons/svg/svg/edit/outline.svg";
import { ReactComponent as Download } from "@material-icons/svg/svg/download/outline.svg";
import { ReactComponent as CreditCardOff } from "@material-icons/svg/svg/credit_card_off/outline.svg";

import { ReactComponent as Menu } from "src/img/menu.svg";

import { type Icon } from "@k8slens/lds-icons/lib/es/Icon/Icon.d";
import { SVGIcon } from "@k8slens/lds-icons";

export const MenuIcon: Icon = ({ ...props }) => <SVGIcon icon={Menu} {...props} />;
export const RepeatIcon: Icon = ({ ...props }) => <SVGIcon icon={Repeat} {...props} />;
export const ContextMenuIcon: Icon = ({ ...props }) => <SVGIcon icon={ContextMenu} {...props} />;
export const InfoIcon: Icon = ({ ...props }) => <SVGIcon icon={Info} {...props} />;
export const EditIcon: Icon = ({ ...props }) => <SVGIcon icon={Edit} {...props} />;
export const DownloadIcon: Icon = ({ ...props }) => <SVGIcon icon={Download} {...props} />;
export const CreditCardOffIcon: Icon = ({ ...props }) => <SVGIcon icon={CreditCardOff} {...props} />;
